<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="title_head"><span class="right_1" epub:type="pagebreak" id="page_ii" title="ii"><b>The Wedding Secret</b></span></p>
<p class="title_aut"><i>Kianna Alexander</i></p>
<p class="title_logo"><img alt="image" src="images/logo.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369702654_Title.vue?0cb86fe6